<template>
  <div class="navigation" :class="{ 'side-nav-is-open': sideNavIsOpen }">
    <TopNav
      v-if="!shouldSeeRestrictedNavigation"
      :model="model"
      @open-side-nav="openSideNav"
      :side-nav-is-open="sideNavIsOpen"
    />
    <GuestTopNav v-if="shouldSeeRestrictedNavigation" :model="model" />
    <SideNav
      v-if="!shouldSeeRestrictedNavigation"
      :side-nav-is-open="sideNavIsOpen"
      @nav-state-changed="setSideNavIsOpen"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { UserSelfDocumentApiModel } from "../../api-models";
import SideNav from "./side-nav/side-nav.vue";
import TopNav from "./top-nav.vue";
import GuestTopNav from "./guest-top-nav.vue";

const props = defineProps<{
  model: UserSelfDocumentApiModel;
}>();

const sideNavIsOpen = ref(false);

watch(sideNavIsOpen, (isOpen) => {
  const searchButtonElement = document.getElementById("search-button");
  if (!searchButtonElement) {
    return;
  }

  if (isOpen) {
    searchButtonElement.style.pointerEvents = "none";
  } else {
    setTimeout(() => {
      searchButtonElement.style.pointerEvents = "auto";
    }, 1);
  }
});

const shouldSeeRestrictedNavigation = computed(() => {
  const isFullMember = props.model.platformPermissions.includes("FullMembershipAccess");
  const isAssessPlanUser = props.model.platformPermissions.includes("AssessPlanAccess");
  const isFullMemberWithAssessPlanLicence = isFullMember && isAssessPlanUser;
  const isPlatformAdmin = props.model.platformPermissions.includes("AdministerPlatform");
  return (
    !isFullMember ||
    isFullMemberWithAssessPlanLicence ||
    isPlatformAdmin ||
    !props.model.hasCompletedFoundationsSession
  );
});

function openSideNav(): void {
  sideNavIsOpen.value = true;
}

function setSideNavIsOpen(isOpen: boolean): void {
  sideNavIsOpen.value = isOpen;
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import (reference) "../../styles/bootstrap/variables.less";

.navigation {
  // The following styles are for elements within top-nav AND side-nav
  button {
    padding: 0;
    margin: 0;
    border: none;
    text-align: initial;
    background-color: transparent;
    cursor: pointer;
  }

  .side-nav-toggle-btn {
    display: none;
    padding: 0 15px;
    position: absolute;
    z-index: 9999;
    width: 60px;
    height: @navbar-height;

    .burger-menu,
    .burger-menu::before,
    .burger-menu::after {
      content: "";
      position: fixed;
      width: 21px;
      height: 3px;
      background: @navbar-default-link-color;
      border-radius: 20px;
    }

    .burger-menu::before {
      transform: translateY(-7px);
    }

    .burger-menu::after {
      transform: translateY(7px);
    }
  }

  @media (max-width: @screen-xxs-max) {
    &.side-nav-is-open {
      .search-bar,
      .notifications {
        display: none;
      }

      .side-nav-toggle-btn {
        display: block;
      }
    }
  }
}
</style>
